export default "__VITE_ASSET__DPMIrmrX__"